import React, { FC } from "react";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ChevronLeft: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faChevronLeft} {...props} />
);
